<template>
  <div class="father" style="padding: 0 10px;">
    <div class="left">
      <div class="dyh-line-group">
        <span class="dyh-line-group-label">子服务商信息</span>
        <el-input size="small" clearable v-model="searchservice_name" placeholder="输入店铺名称搜索店铺"></el-input>
        <el-button size="small" type="primary" @click="searchServiceName">搜索</el-button>
      </div>
      <div v-if="wtytbshow">
        <wty-table ref="wtyTableRef" :who="'sonService'" :operate="'查看详细信息'" :wtycolumnList="wtycolumnList"
          :height="'500px'" :wtytbList="wtytbList" @wtyTbreturn="wtyTbreturn"></wty-table>
      </div>
    </div>
    <div class="right">
      <el-scrollbar wrapStyle="overflow-x:hidden;" style="width: 100%;height: 500px;background-color: #fff;">
        <div class="father">
          <el-form label-width="300px" style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
            ref="dataFormRef" :model="service" :rules="rules" label-position="top">
            <div class="title">
              基本信息
            </div>
            <el-form-item label="营业执照（上传营业执照进行识别）：" style="height:193px;" v-if="!modify">
              <uploadImg class="uploadImg" :imgTitle="'yyzz'" @getReturn="getReturn" @removeImg="removeImg">
                <template slot="centerName">
                  营业执照
                </template>
              </uploadImg>
            </el-form-item>
            <div v-for="(item, index) in formList" :key="index">
              <div class="title" style="" v-if="index == 5">
                选填信息
              </div>
              <el-form-item :label="item.label" :prop="item.value">
                <el-input clearable :disabled="modify" :show-password="item.value == 'pass_word'"
                  v-model="service[item.value]" :placeholder="`请输入${item.label}`">
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="wty-footer">
        <el-button type="danger" @click="resetForm"> 新建 </el-button>
        <!-- <el-button v-if="modify" type="primary" @click="saveType">
          保存店铺状态 </el-button> -->
        <el-button type="primary" :disabled="modify" @click="ServiceGenerate">
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import wtyTable from "@/components/wty-table";
import { serviceGenerate, getserviceList } from "@/api/service";
import uploadImg from "@/components/uploadImg.vue";
export default {
  name: "sonService",
  data() {
    return {
      modify: false,
      searchservice_name: "",
      wtytbshow: false,
      wtycolumnList: [],
      wtytbList: [],
      service: {
        wtytbshow: true,
        pass_word: "",
        service_name: "",
        address: "",
        contacts: "",
        mobile_no: "",
        bank_account_no: "",
        bank_account_name: "",
        bank_full_name: "",
        bussiness_license: ""
      },
      formList: [],
      rules: this.getRules()
    };
  },
  components: { wtyTable, uploadImg },
  mounted() {
    this.getService();
  },
  methods: {
    removeImg(imgTitle) {
      /* switch (imgTitle) {
        case "fm":
          this.img_legal_id_back = "";
          break;
        case "zm":
          this.img_legal_id_front = "";
          break;
        case "yyzz":
          this.img_license = "";
          break;
      } */
    },
    getReturn(res) {
      console.log("识别内容返回值：", res);
      if (JSON.stringify(res) === "{}") {
        this.warnMessage("未识别出有效内容，请重试");
      } else {
        this.successMessage("识别成功");
        this.service.service_name = res.commpanyName;
        this.service.address = res.address;
        this.service.contacts = res.legalPerson;
        this.service.bussiness_license = res.licenseCode;
      }
      console.log("服务商信息：", this.service);

      // res.media_no = this.merchant.license_code;
    },
    //TODO: 查询详情之后
    wtyTbreturn(res) {
      this.service = { ...res };
      this.modify = true;
    },
    searchServiceName() {
      this.$refs.wtyTableRef.wtyTableIn(this.searchservice_name);
      // this.modify = false;
      this.$refs.dataFormRef.resetFields();
      this.$refs.wtyTableRef.hideRow();
    },
    async getService() {
      this.wtytbshow = false;
      const result = await getserviceList();
      console.log(result);
      if (this.testR(result)) {
        this.wtytbList = result.data.resp_data;
      }
      this.wtytbshow = true;
    },
    async ServiceGenerate() {
      var data = { ...this.service };
      data.business_license = await this.$encrypt(
        this.service.bussiness_license,
        "business_license"
      );
      data.pass_word = await this.$encrypt(this.service.pass_word, "pass_word");
      data.mobile_no = await this.$encrypt(this.service.mobile_no, "mobile_no");
      if (data.bank_account_no !== "" || data.bank_account_no.length !== 0) {
        data.bank_account_no = await this.$encrypt(
          this.service.bank_account_no,
          "bank_account_no"
        );
      }
      // console.log(data);
      const res = await serviceGenerate(data);
      if (this.testR(res)) {
        this.successMessage(res.data.resp_data.desc);
        this.getService();
      }
      // console.log("创建子服务商返回：",res);
    },
    //重置内容
    resetForm() {
      const that = this;
      this.$confirm("此操作将清空所有内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.modify = false;
          that.$refs.dataFormRef.resetFields();
          this.$refs.wtyTableRef.hideRow();
          this.successMessage("内容重置成功！");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getRules() {
      let list = [
        { label: "营业执照号：", value: "bussiness_license", type: "false" },
        { label: "服务商名称：", value: "service_name", type: "false" },
        { label: "登录密码：", value: "pass_word", type: "false" },
        { label: "联系人：", value: "contacts", type: "false" },
        { label: "手机号码：", value: "mobile_no", type: "false" },
        { label: "地址：", value: "address", type: "true" },
        { label: "银行账户：", value: "bank_account_no", type: "true" },
        { label: "账户名：", value: "bank_account_name", type: "true" },
        { label: "银行全名：", value: "bank_full_name", type: "true" }
      ];
      var rules = {};
      var wtycolumnList = [];

      //生成  rules  规则
      for (let i = 0; i < list.length; i++) {
        if (list[i].type === "false") {
          rules[list[i].value] = [
            {
              required: true,
              message: `请输入${list[i].label}`,
              trigger: "blur"
            }
          ];
        }
        // if (i == 7) break;
      }
      wtycolumnList.push({
        prop: "service_no",
        align: "center",
        label: "服务商ID",
        width: "200",
        fixed: "left"
      });
      wtycolumnList.push({
        prop: "service_name",
        align: "center",
        label: "服务商名称",
        width: "200",
        fixed: false
      });
      this.$nextTick(() => {
        this.formList = list;
        this.wtycolumnList = wtycolumnList;
      });
      return rules;
    }
  }
};
</script>
<style lang="less" scoped>
.father {
  height: 100%;
  display: inline-block;
  background-color: #fff;
  border-radius: 5px;
}

.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}

.left {
  float: left;
  width: 50%;
  min-width: 600px;
  // height: 630px;
  background-color: #fff;
  padding-right: 20px;

  .left-title {
    padding: 0 20px;
    width: 100%;
    height: 50px;
    // background-color: rgb(254, 103, 103);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.right {
  // width: calc(100% - 650px);
  float: left;
  width: 50%;
  min-width: 600px;
}

.el-input {
  width: 400px;
}

.wty-footer {
  height: 50px;

  .el-button {
    width: 200px;
  }
}
</style>
